import { DatasetAccessLevel } from "datasets/types/enums/access-level";
import Dataset from "datasets/types/interfaces/dataset";
import { useCohortExplorerEnabled } from "~/pages/manifold-nextgen/hooks/useCohortExplorerEnabled";

// A dataset's Cohort Explorer configuration is visible only to its owner, and
// only when the Cohort Explorer feature is enabled. Drives the "Cohort Explorer"
// entry on both the full dataset page (DatasetDetail) and the session context
// sidebar (SessionContextDatasetDetail).
export const useCanViewCohortExplorer = (dataset: Dataset | undefined): boolean => {
  const isEnabled = useCohortExplorerEnabled();
  return isEnabled && dataset?.access_level === DatasetAccessLevel.OWNER;
};
